










































import Vue from 'vue'
import { Post, User, CommentId, Comment } from 'types'
import { Component, Prop } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'
import { namespace } from 'vuex-class'
import IntlMixin from 'vuemixins/intl_mixin'
import SurfacePostComment from 'vuecomponents/surface_post_comment.vue'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import AvatarImage from 'vuecomponents/avatar_image.vue'

const commentModule = namespace('comment')

@Component({
  components: {
    AvatarImage,
    BaseIcon,
    SurfacePostComment,
    MultilineInput,
  },
  mixins: [IntlMixin],
})
export default class SurfacePostComments extends Vue {
  isAddCommentFocused = false

  @Prop({ default: null }) post!: Post
  @Prop({ default: null }) user!: User
  @Prop({ default: null }) commentIds!: CommentId[]
  @Prop({ default: null }) comments!: { [id: number]: Comment }
  @Prop({ default: false }) isCommentable!: boolean
  @Prop({ default: null }) commentBeingEditedId!: CommentId

  @commentModule.Getter newCommentBodyForPostCid
  @commentModule.Action addCommentInputFocused
  @commentModule.Action addCommentInputBlurred
  @commentModule.Action updateNewCommentBody

  get commentsList(): Comment[] {
    return this.commentIds.map((id) => this.comments[id])
  }

  get newCommentBody(): string {
    return this.newCommentBodyForPostCid(this.post.cid)
  }

  showCommentActionMenu($event): void {
    this.$emit('show-comment-action-menu', $event)
  }

  stopEditingComment(): void {
    this.$emit('stop-editing')
  }

  editComment($event): void {
    this.$emit('edit', $event)
  }

  publishComment(): void {
    if (!this.newCommentBody) return

    this.$emit('create', {
      postId: this.post.id,
      body: this.newCommentBody,
    })
    this.updateNewCommentBody({ postCid: this.post.cid, body: '' })
    const vueInputElement = this.$refs.addCommentInput as MultilineInput
    vueInputElement.focus()
  }

  submit(): void {
    this.publishComment()
  }

  onAddCommentFocus(): void {
    this.isAddCommentFocused = true
    this.addCommentInputFocused({ postId: this.post.id })
  }

  onAddCommentBlur(): void {
    this.isAddCommentFocused = false
    this.addCommentInputBlurred({ postId: this.post.id })
  }

  onAddCommentInput(body): void {
    this.updateNewCommentBody({ postCid: this.post.cid, body })
  }

  onAddCommentSubmitClicked(): void {
    this.publishComment()
  }
}
